export enum PaymentStatus {
  /* Betaling is gestart */
  Start = 'Start',
  /* Betaling nog NIET ontvangen */
  Open = 'Open',
  /* Betaling ontvangen */
  Success = 'Success',
  /* Geannuleerd door klant */
  Cancelled = 'Cancelled',
  /* Betaling is niet ontvangen binnen de vooraf ingestelde tijd */
  Expired = 'Expired',
  /* Betaling is om onbekende reden NIET ontvangen */
  Failure = 'Failure',
  /* Onbekende gebeurtenis (waarschijnlijk SAP of database probleem) */
  Unknown = 'Unknown'
}
